import React from "react";
import { LoadingRegion, useDataLoader, formatDate } from "@optimed/react";
import { syncService } from "../api";
import { Badge, Table } from "@optimed/react";
import { SystemType, EventStatus } from "../api/models";
import { Identifier } from "./Identifier";

export function EventsView() {
  const [events, loading] = useDataLoader(() => syncService.events());
  return (
    <LoadingRegion promise={loading}>
      <Table colLabels={["Data", "Typ", "Status"]} small={true}>
        <tbody>
          {(!events || !events.length) && (
            <tr>
              <td colSpan={3}>Brak zdarzeń</td>
            </tr>
          )}
          {events?.map(x => (
            <tr key={x.id}>
              <td>
                <div>{formatDate(x.readAt, "yyyy-MM-dd HH:mm:ss")}</div>
                <div>
                  <span className="small">Data utworzenia: {formatDate(x.createdAt, "yyyy-MM-dd HH:mm:ss")}</span>
                </div>
              </td>
              <td>
                <div>
                  {x.system === SystemType.Docplanner ? "Znany Lekarz" : "Optimed NXT"}, {x.type}
                </div>
                <div>
                  <Identifier value={x.id} />
                </div>
              </td>
              <td>
                {x.status === EventStatus.Waiting && <Badge type="secondary" text="Oczekuje na przetworzenie" />}
                {x.status === EventStatus.Completed && <Badge type="success" text="Przetworzony" />}
                {x.status === EventStatus.Faulted && <Badge type="danger" text="Błąd" />}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </LoadingRegion>
  );
}
